import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { services } from '../data/mock';
import { CheckCircle2 } from 'lucide-react';

const Services = () => {
  return (
    <div className="min-h-screen pt-32 pb-20">
      {/* Hero Section */}
      <section className="container-luxury mb-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#111111] border border-[#D4AF37]/20 rounded-full mb-8">
            <span className="text-sm text-[#D4AF37] font-medium tracking-wider">НАШИТЕ УСЛУГИ</span>
          </div>
          
          <h1 className="heading-luxury mb-6">
            Цялостни решения за <span className="gradient-text">недвижими имоти</span>
          </h1>
          
          <p className="text-xl text-[#A9A9A9] leading-relaxed">
            От консултация и анализ до финализиране на сделката — процес с гарантирана правна и финансова сигурност
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="container-luxury space-y-24">
        {services.map((service, index) => {
          const IconComponent = Icons[service.icon];
          const isEven = index % 2 === 0;
          
          return (
            <div 
              key={service.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                isEven ? '' : 'lg:grid-flow-dense'
              }`}
            >
              {/* Icon & Title Column */}
              <div className={`space-y-6 ${isEven ? '' : 'lg:col-start-2'}`}>
                <div className="inline-flex w-20 h-20 bg-[#D4AF37]/10 rounded-xl items-center justify-center">
                  {IconComponent && (
                    <IconComponent className="w-10 h-10 text-[#D4AF37]" />
                  )}
                </div>
                
                <h2 className="text-4xl font-serif font-semibold text-[#F6F2E8]">
                  {service.title}
                </h2>
                
                <p className="text-[#D4AF37] font-medium text-lg">
                  {service.forWhom}
                </p>
              </div>

              {/* Benefits Column */}
              <div className={`bg-[#111111] border border-[#D4AF37]/10 rounded-xl p-8 ${
                isEven ? '' : 'lg:col-start-1 lg:row-start-1'
              }`}>
                <h3 className="text-xl font-semibold text-[#F6F2E8] mb-6">
                  Какво получавате:
                </h3>
                
                <ul className="space-y-4">
                  {service.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start space-x-3">
                      <CheckCircle2 className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                      <span className="text-[#A9A9A9] leading-relaxed">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </section>

      {/* CTA Section */}
      <section className="container-luxury mt-24">
        <div className="bg-gradient-to-br from-[#111111] via-[#0B0B0B] to-[#111111] border border-[#D4AF37]/20 rounded-2xl p-12 text-center">
          <h2 className="text-3xl lg:text-4xl font-serif font-semibold text-[#F6F2E8] mb-6">
            Готови да започнем?
          </h2>
          <p className="text-lg text-[#A9A9A9] mb-8 max-w-2xl mx-auto">
            Свържете се с нас за безплатна първоначална консултация
          </p>
          <Link to="/contact" className="btn-primary">
            Запази консултация
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
